import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getPurchaseListApi } from '~/features/purchase/api/get-purchase-list.api';
import { getUserApi } from '~/features/user/api/get-user.api';

import type { PayloadAction } from '@reduxjs/toolkit';

import type { Purchase } from '~/features/purchase/types/purchase.type';
import type { User } from '~/features/user/types/user.type';

export interface UserDetailModalState {
  isLoading: boolean;
  user: User | null;
  purchases: Purchase[];
}

const initialState: UserDetailModalState = {
  isLoading: false,
  user: null,
  purchases: [],
};

/**
 * 유저 상세 모달 데이터 조회
 * - 유저 정보 + 결제 내역 동시 조회
 */
export const fetchUserDetailModalData = createAsyncThunk<
  { user: User; purchases: Purchase[] },
  number,
  { rejectValue: unknown }
>('userDetailModal/fetchData', async (userId, { rejectWithValue }) => {
  try {
    const [userRes, purchasesRes] = await Promise.all([
      getUserApi(userId),
      getPurchaseListApi({ userId, page: 1, perPage: 100 }),
    ]);

    return {
      user: userRes.data.data,
      purchases: purchasesRes.data.data,
    };
  } catch (err) {
    return rejectWithValue(err);
  }
});

const UserDetailModalSlice = createSlice({
  name: 'userDetailModal',
  initialState,
  reducers: {
    resetUserDetailModal: () => initialState,
    setUserDetailModalUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchUserDetailModalData.pending, state => {
        state.isLoading = true;
      })
      .addCase(fetchUserDetailModalData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload.user;
        state.purchases = action.payload.purchases;
      })
      .addCase(fetchUserDetailModalData.rejected, state => {
        state.isLoading = false;
      });
  },
});

export const { resetUserDetailModal, setUserDetailModalUser } = UserDetailModalSlice.actions;
export default UserDetailModalSlice;
